import React from 'react';
import { MainLayout } from '../components/MainLayout';
import { useApp } from '../components/AppContext';

export function ContractDataIntro() {
  const { navigateDirectly } = useApp();

  const handleContinue = () => {
    navigateDirectly('app-contract-data');
  };

  return (
    <MainLayout showBack showBottomNav={false}>
      <div className="intro-screen-container">
        <div className="intro-header">
          <div className="intro-icon">
            <span className="text-4xl">📋</span>
          </div>
          <h2 className="text-2xl font-bold text-[var(--ucm-text-dark)] mb-2">
            Fill Contract Data
          </h2>
        </div>
        
        <div className="intro-content">
          <h3 className="text-xl font-semibold text-[var(--ucm-text-dark)] mb-6">
            Why we need this information
          </h3>
          
          <div className="intro-reasons">
            <div className="reason-item">
              <div className="reason-icon">
                <span className="text-white text-sm">⚖️</span>
              </div>
              <div className="reason-text">
                <strong className="block font-semibold text-[var(--ucm-text-dark)] mb-1">
                  Legal Requirements
                </strong>
                <p className="text-sm text-[var(--ucm-text-medium)] leading-relaxed m-0">
                  Emergency contacts and basic information are required by German labor law for all participants.
                </p>
              </div>
            </div>
            
            <div className="reason-item">
              <div className="reason-icon">
                <span className="text-white text-sm">🚨</span>
              </div>
              <div className="reason-text">
                <strong className="block font-semibold text-[var(--ucm-text-dark)] mb-1">
                  Safety & Emergency
                </strong>
                <p className="text-sm text-[var(--ucm-text-medium)] leading-relaxed m-0">
                  In case of emergencies at the airport, we need to know who to contact and any medical considerations.
                </p>
              </div>
            </div>
            
            <div className="reason-item">
              <div className="reason-icon">
                <span className="text-white text-sm">✈️</span>
              </div>
              <div className="reason-text">
                <strong className="block font-semibold text-[var(--ucm-text-dark)] mb-1">
                  Airport Security
                </strong>
                <p className="text-sm text-[var(--ucm-text-medium)] leading-relaxed m-0">
                  Airport authorities require basic participant information for security clearance and access control.
                </p>
              </div>
            </div>
          </div>
          
          <div className="trust-message">
            <p className="text-sm text-[var(--ucm-dark-blue)] leading-relaxed m-0">
              <strong>Secure handling:</strong> Contract data is processed according to airport security standards and German privacy laws.
            </p>
          </div>
        </div>
        
        <div className="intro-actions">
          <button
            onClick={handleContinue}
            className="w-full h-14 bg-[var(--ucm-primary-teal)] text-white font-semibold rounded-full hover:bg-[var(--ucm-primary-teal-hover)] transition-colors duration-200"
          >
            Continue to Contract Data
          </button>
        </div>
      </div>
    </MainLayout>
  );
}